var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmbeddedFormIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#225da4",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.6523 4.584a0.83333 0.83333 0 0 0-0.58594 0.25391l-5 5.1797a0.83342 0.83342 0 0 0 0.021484 1.1797l5 4.8184a0.83333 0.83333 0 0 0 1.1797-0.02148 0.83333 0.83333 0 0 0-0.023437-1.1777l-4.3984-4.2402 4.4199-4.5801a0.83333 0.83333 0 0 0-0.019531-1.1797 0.83333 0.83333 0 0 0-0.59375-0.23242z",
    color: "#000000",
    strokeLinejoin: "round",
    style: {
      InkscapeStroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.754 4.8164a0.83333 0.83333 0 0 0-0.01953 1.1797l4.4199 4.5801-4.3984 4.2402a0.83333 0.83333 0 0 0-0.02148 1.1777 0.83333 0.83333 0 0 0 1.1777 0.02148l5-4.8184a0.83342 0.83342 0 0 0 0.02148-1.1797l-5-5.1797a0.83333 0.83333 0 0 0-1.1797-0.021484z",
    color: "#000000",
    strokeLinejoin: "round",
    style: {
      InkscapeStroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.811 0.8457a0.83333 0.83333 0 0 0-0.96484 0.67773l-2.916 16.666a0.83333 0.83333 0 0 0 0.67578 0.96484 0.83333 0.83333 0 0 0 0.96484-0.67774l2.918-16.666a0.83333 0.83333 0 0 0-0.67773-0.96484z",
    color: "#000000",
    style: {
      InkscapeStroke: "none"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmbeddedFormIcon);
export default __webpack_public_path__ + "static/media/embedded-form-icon.a0603d87eb891fa6234eb5396fb38dd2.svg";
export { ForwardRef as ReactComponent };